
export const FeedHeader = () => {
  return (
    <h1 className="text-xl sm:text-2xl font-bold p-4 border-b border-flux-cyan/10">
      <span className="text-white">Your</span>{" "}
      <span className="text-flux-cyan">Feed</span>
    </h1>
  );
};
